export default {
  setGrades(state, data) {
    state.grades = data;
  },

  clearGrades(state) {
    state.grades = [];
  },
};
